export default __webpack_public_path__ + "static/portfolio-10-0484f770a0fbe5029e305d51c3599d16.jpg";